import React from "react";
import PropTypes from "prop-types";
import { TransitionPortal } from "gatsby-plugin-transition-link";

import Sidebar from "../Sidebar";
import SwtichTheme from "../SwitchTheme";

import Particle from "../Particles";

import GlobalStyles from "../../styles/global";

import * as S from "./styles";

const Layout = ({ children }) => {
  return (
    <S.LayoutWrapper>
      <Particle />
      <GlobalStyles />
      <TransitionPortal level="top">
        <Sidebar />
      </TransitionPortal>
      <SwtichTheme />
      <S.LayoutMain>{children}</S.LayoutMain>
    </S.LayoutWrapper>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
